import { Contact, ContactNode } from '@api';
import { Epic } from 'redux-observable';
import CheckoutServiceV2 from 'src/js/enrol/services/CheckoutApiService';
import { Create, Request } from '../../common/epics/EpicUtils';
import { IshState } from '../../services/IshState';
import { getCheckoutModelFromBackend } from '../actions/Actions';
import * as Actions from '../containers/summary/actions/Actions';
import { ContactNodeService } from '../services/ContactNodeService';

const request: Request<ContactNode, { contact: Contact, uncheckItems: boolean, payerId: string }> = {
  type: Actions.GET_CONTACT_NODE_AND_MODEL_FROM_BACKEND,
  getData: (payload, state: IshState) => CheckoutServiceV2.getContactNode(payload.contact, state.checkout.summary,  state.cart, payload.payerId),
  processData: (value, state, payload) => {
    if (payload.uncheckItems) {
      // set selected to false for all items
      const itemTypes = ['enrolments', 'waitingLists', 'articles', 'applications', 'memberships'];
      itemTypes.forEach(type => {
        if (value[type] && value[type].length) {
          value[type] = value[type].map(item => ({ ...item, selected: false }));
        }
      });
    }
    const relationsUpdateActions = ContactNodeService.getRelationsUpdateActions([value]);

    return [
      Actions.addContactNodeToState(value),
      getCheckoutModelFromBackend(),
      ...relationsUpdateActions
    ];
  },
};

export const GetContactNode: Epic<any, IshState> = Create(request);
